import { useLocation } from '@tanstack/react-router';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStickyNoteStore } from '@/shared/stores/sticky-note-store';
import { useAddStickyNoteMode } from '../model/useAddStickyNoteMode';
import { StickyNoteItem } from './StickyNoteItem';

/**
 * 付箋オーバーレイ
 * 現在のURLに一致する付箋を表示し、追加モードを有効化する
 * isDebugEnabled() 時のみ MainRouteLayout でレンダリングされる
 */
export const StickyNoteOverlay: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const notes = useStickyNoteStore((s) => s.notes);
  const isVisible = useStickyNoteStore((s) => s.isVisible);
  const isAddMode = useStickyNoteStore((s) => s.isAddMode);

  useAddStickyNoteMode();

  const visibleNotes = notes.filter((note) => note.url === pathname);

  return (
    <>
      {/* 追加モード時のヒント表示 */}
      {isAddMode && (
        <div className="pointer-events-none fixed inset-0 z-50 flex items-start justify-center pt-4">
          <div className="pointer-events-auto rounded-lg bg-stone-900 px-4 py-2 text-sm text-white shadow-lg">
            {t('debug-menu.sticky-note.add-mode-hint')}
          </div>
        </div>
      )}

      {/* 付箋の描画 */}
      {isVisible && visibleNotes.map((note) => <StickyNoteItem key={note.id} note={note} />)}
    </>
  );
};
